/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{FloatBindUniform as o}from"../../shaderModules/FloatBindUniform.js";import{glsl as d}from"../../shaderModules/glsl.js";function e(e){e.uniforms.add(new o("dpDummy",()=>1)).code.add(d`vec3 dpAdd(vec3 hiA, vec3 loA, vec3 hiB, vec3 loB) {
vec3 hiD = hiA + hiB;
vec3 loD = loA + loB;
return  dpDummy * hiD + loD;
}`)}export{e as DoublePrecision};
